import * as types from "../actions/actionTypes";
import initialState from "./initialState";

const customerResgisteration = initialState.customerResgisteration;

export default function customerRegisterationReducer(state = initialState.customerResgisteration, action) {
    switch (action.type) {
        case types.CUSTOMER_LOOKUP_INITIATED:
            return {
                ...customerResgisteration,
                initiated: true,
                message: null,
                userExists: false,
                isOtpEnabled : true
            };
        case types.CUSTOMER_LOOKUP_FAILURE:
            return {
                ...customerResgisteration,
                initiated: false,
                message: action?.message,
                userExists: false,
                isUserCheckCompleted : false,
                isOtpEnabled : true
            };
        case types.CUSTOMER_LOOKUP_SUCCESS:
            return {
                ...customerResgisteration,
                initiated: false,
                message: action?.message,
                userExists: action?.userExists,
                userConcent: action?.userConcent,
                isUserCheckCompleted : true,
                isOtpEnabled : action?.isOtpEnabled
            };
        case types.CUSTOMER_REGISTERATION_INITIATED:
            return {
                ...state,
                initiated: true,
            };
        case types.CUSTOMER_REGISTERATION_FAILURE:
            return {
                ...state,
                initiated: false,
                message: action?.message,
                registerationSuccess : false
            };
        case types.CUSTOMER_REGISTERATION_SUCCESS:
            return {
                ...customerResgisteration,
                initiated: false,
                message: action?.message,
                registerationSuccess : true,
                isUserCheckCompleted:true
            };
        default:
            return state;
    }
}
